// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__ayB6w","currentPage":"Pagination_currentPage__l4uw+","totalPages":"Pagination_totalPages__prO4h"};